export default {
  methods: {
    /**
     * @description Fetching List data
     * @param parameters
     * @return {Promise<*>}
     */
    async getList(parameters) {
      return await this.$client
        .execute({
          operationId: 'List_getList',
          method: 'post',
          parameters,
          requestContentType: 'application/x-www-form-urlencoded',
        })
        .catch((e) => console.error(e))
    },
    /**
     * @description Fetching List setup
     * @param parameters
     * @return {Promise<*>}
     */
    async getListSetup(parameters) {
      return await this.$client
        .execute({
          operationId: 'List_getListSetup',
          parameters,
          requestContentType: 'application/x-www-form-urlencoded',
        })
        .catch((e) => console.error(e))
    },
    /**
     * @description Fetching action buttons
     * @param parameters
     * @return {Promise<*>}
     */
    async getButtonList(parameters) {
      return await this.$client
        .execute({
          operationId: 'List_getButtonList',
          method: 'post',
          parameters,
          requestContentType: 'application/x-www-form-urlencoded',
        })
        .catch((e) => console.error(e))
    },
    /**
     * @description Exporting data from the list
     * @param parameters
     * @return {Promise<*>}
     */
    async exportList(parameters) {
      return await this.$client.execute({
        operationId: 'List_exportList',
        method: 'post',
        parameters,
      })
    },
    /**
     * @description Getting progress data
     * @param parameters
     * @return {Promise<*>}
     */
    async getProgress(parameters) {
      return await this.$client.execute({
        operationId: 'Progress_checkList',
        method: 'get',
        parameters,
      })
    },
  },
}
